import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToId, EASE } from "@/lib/motion";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: EASE, delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-ink/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => scrollToId("top")}
          className="flex items-center gap-2 group"
        >
          <span className="w-2.5 h-2.5 rounded-sm bg-acid shadow-[0_0_18px_2px_rgba(212,255,61,0.5)] group-hover:rotate-45 transition-transform duration-500" />
          <span className="font-display font-extrabold tracking-tight text-xl text-paper">
            AXIOM
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10 font-mono text-[11px] uppercase tracking-[0.2em] text-paper/60">
          {[
            ["Platform", "showcase"],
            ["Manifesto", "manifesto"],
            ["Numbers", "metrics"],
          ].map(([label, id]) => (
            <button
              key={id}
              data-testid={`nav-${id}`}
              onClick={() => scrollToId(id)}
              className="hover:text-acid transition-colors duration-300"
            >
              {label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-book-demo"
          onClick={() => scrollToId("book")}
          className="group relative overflow-hidden rounded-full bg-acid px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-ink font-bold"
        >
          <span className="relative z-10">Book a demo</span>
          <span className="absolute inset-0 bg-paper translate-y-full group-hover:translate-y-0 transition-transform duration-400 ease-out" />
          <span className="absolute inset-0 z-10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-ink">
            Book a demo
          </span>
        </button>
      </div>
    </motion.header>
  );
};
